"use client"

import { afterPaint } from "@/lib/helpers/after-paint"
import type { Money } from "@/lib/money"
import type { StoreProduct } from "@/platform/api/store-contract"
import { isAppBridgeAvailable } from "@/platform/bridge/use-native-bridge"
import { createAndStoreAddToCartConversionId } from "@/platform/observability/analytics/conversions"
import { trackBeginCheckout, trackCheckoutButtonClick } from "@/platform/observability/analytics/v2/checkout"
import { buildGA4ItemFromProduct, priceEventParams } from "@/platform/observability/analytics/v2/mappers"
import { trackAddToCart } from "@/platform/observability/analytics/v2/search"

const emitCheckoutTap = (product: StoreProduct, variant: StoreProduct["variants"][number], price: Money | null, conversionId: string, nativeCheckout: boolean) => {
  const items = [buildGA4ItemFromProduct(product, variant)]
  const { currency, value } = priceEventParams(price)
  trackAddToCart({ currency, value, items, conversionId })
  trackBeginCheckout({ currency, value, items })
  trackCheckoutButtonClick({
    productId: product.id ?? "",
    variantId: variant.id,
    originalPrice: variant.original_price ?? undefined,
    calculatedPrice: variant.calculated_price ?? undefined,
    productCategories: product.categories?.map((category) => category.name),
    productCollection: product.collection?.handle ?? undefined,
    in_stock: product.variants.some((candidate) => (candidate.inventory_quantity || 0) > 0 || candidate.allow_backorder),
    nativeCheckout,
  })
}

export const trackPdpCheckoutTap = (product: StoreProduct, variant: StoreProduct["variants"][number], price: Money | null) => {
  const conversionId = createAndStoreAddToCartConversionId()
  const nativeCheckout = isAppBridgeAvailable()
  const track = () => emitCheckoutTap(product, variant, price, conversionId, nativeCheckout)
  if (nativeCheckout) {
    track()
    return
  }
  afterPaint(track)
}

export const trackPdpCheckoutLinkArrival = (product: StoreProduct, variant: StoreProduct["variants"][number], price: Money | null, conversionId: string) =>
  afterPaint(() => emitCheckoutTap(product, variant, price, conversionId, false))
